import Repository from './Repository'

export default {
  inn(inn) {
    const action = '/check_inn?inn=' + inn

    return Repository.get(action)
  },
  bik(bik) {
    const action = '/check_bik/' + bik

    return Repository.get(action)
  },
  getcode(login) {
    const action = '/get-code'

    return Repository.post(action, { phone: login })
  },
}
